// JS que activa el sliders de 1 solo producto. Ej. seccion slider de imagenes vista PRODUCTO

$(document).ready(function(){
    // variables

    // acciones
    $('.js-slide-product-dots').each( function (){
        slideProductDotsContent($(this))
    })

    // funciones
    function slideProductDotsContent(item) {
        $(`.js-slide-product-dots__content-${item.data('slide-product-dots__id')}`).slick({
            dots: false,
            arrows: true,
            infinite: true,
            autoplay: false,
            autoplaySpeed: item.data('slide-product-dots__time'),
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            prevArrow: $(`.js-slide-product-dots__prev-${item.data('slide-product-dots__id')}`),
            nextArrow: $(`.js-slide-product-dots__next-${item.data('slide-product-dots__id')}`),
            asNavFor: `.js-slide-product-dots__tumbs-${item.data('slide-product-dots__id')}`,
        })

        $(`.js-slide-product-dots__tumbs-${item.data('slide-product-dots__id')}`).slick({
            dots: false,
            arrows: false,
            centerMode: false,
            focusOnSelect: true,
            infinite: false,
            variableWidth: true,
            focusOnSelect: true,
            slidesToScroll: 1,
            asNavFor: `.js-slide-product-dots__content-${item.data('slide-product-dots__id')}`,
        })
    }

})